"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var commonConfig = {
  MAP_API_KEY: globalConfigExists() ? window.globalConfigs.getConfig("GMAPS_API_KEY") : process.env.REACT_APP_GMAPS_API_KEY,
  tenantId: globalConfigExists() ? window.globalConfigs.getConfig("STATE_LEVEL_TENANT_ID") : process.env.REACT_APP_DEFAULT_TENANT_ID,
  forgotPasswordTenant: "ch.chandigarh"
};

function globalConfigExists() {
  return typeof window.globalConfigs !== "undefined" && typeof window.globalConfigs.getConfig === "function";
}

exports.default = commonConfig;
var screenConfigPaths = exports.screenConfigPaths = {
  pgrCitizenConfigPath: "pgr-citizen/config/forms/specs/"
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/common.js
// module id = 1824
// module chunks = 1143